import { Link, RecordType } from '@models';

export enum PositionAccuracy {
  'good estimate' = 'Good estimate',
  'GPS' = 'GPS',
  'poorly known (set to placename)' = 'Poorly known (set to placename)',
}

export const Geologists = [
  'Ane Engvik',
  'Arild Andresen',
  'Audun Hjelle',
  'Bjørn Tørudbakken',
  'Dierk Blomeier',
  'Håkon Austrheim',
  'Joachim Jacobs',
  'Oscar Paulsson',
  'Øyvind Sunde',
  'Perle Inge Myhre',
  'Per Terje Osmundsen',
  'Synnøve Elvevold',
  'Tamer Abu-Alam',
  'Thore S. Winsnes',
  'Tore Gjelsvik',
  'Winfried Dallmann',
  'Yoshihide Ohta',
];

export const Expeditions = [
  '1951 Maudheim Expedition',
  '1961 Nordenskiold Land',
  '1966 Albert I Land',
  '1966 Smeerenburgfjorden',
  '1968 Albert I land',
  '1971 H.U. Sverdrupfjella',
  '1972 Motalafjella',
  '1973 St. Jonsfjorden',
  '1974 Ellsworth Mountains',
  '1975 Spitsbergen',
  '1976 Nordaustlandet',
  '1979 Bouvet',
  '1981 NV Spitsbergen',
  '1983 Oscar II Land',
  '1984 Oscar II Land',
  '1985 Gjelsvik - Muhlig-Hofmannfjella',
  '1985 N og V Spitsbergen',
  '1988 Sørkapp Land',
  '1990 Muhlig-Hofmannfjella',
  '1997 Muhlig-Hofmannfjella - Filchnerfjella',
  '1999 Andree Land',
  '1999 Motalafjella',
  '2004 Kongsfjorden',
  '2004 Signehamna',
  '2005 Blomstrandhamna',
  '2009 Nordaustlandet',
  '2015 Prins Karls Forland',
  '2017 Kongsfjorden',
  '2018 Jutulsessen - Hochlinfjella',
  '2019 Kongsfjorden',
  '2019 Raudfjorden',
  '2022 Jutulsessen - Hochlinfjella - Muhlig-Hoffmannfjella',
  'Antarctic',
]

export interface GeologicalSampleDetails {
  cabinetRef?: string;
  collectedYear?: string;
  description?: string;
  draft: boolean;
  expedition?: string;
  fossil: boolean;
  geojson?: GeoJSON.FeatureCollection;
  geologists?: string[];
  links?: Link[];
  lithology?: string;
  originalSampleName?: string;
  placename?: string;
  positionAccuracy?: PositionAccuracy;
  sampleName: string;
  thinSectionRef?: string;
}

export interface GeologicalSample {
  id: string;
  datasetId: string;
  type: RecordType;

  content: GeologicalSampleDetails;

  createdBy: string;
  modifiedBy: string;
  publishedBy: string;
  created: string;
  modified: string;
  published?: string;
}
